import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { SeoData } from '@project_app/config/seo.data';
import { SeoService } from '@core/services/util/seo.service';

@Injectable({
    providedIn: 'root'
})
export class SEOService {
    constructor(
        private meta: Meta,
        private title: Title,
        private seo: SeoService
    ) {}

    addTag(path: string): void {
        const data = SeoData[path] || SeoData['default'];
        for (const key in data) {
            this.meta.updateTag({ name: key, content: data[key] });
        }
    }

    updateTag(path: string): void {
        const data = SeoData[path] || SeoData['default'];
        for (const key in data) {
            if (key === 'title') {
                this.title.setTitle(data.title);
            } else {
                this.meta.updateTag({ name: key, content: data[key] });
            }
        }

        if (!data || !data.title) {
            this.title.setTitle(SeoData['default'].title);
        }

        this.seo.generateTags(data);
    }
}
